<div class="main-container">
	<div class="header-container">
		<h1>WELCOME TO TEST TOOLS</h1>
		<h4>Test tools are a collection of applications that provide a great testing experience.</h4>
		@if ((authService.isLoggedIn$ | async) === false) {
			<div>Please sign in to access our applications.</div>

			<p-button icon="pi pi-sign-in" label="Sign in" routerLink="/login"></p-button>
		}
	</div>

	<div class="main-content-container">
		@if (authService.isLoggedIn$ | async) {
			<div class="link-items-container">
				<a routerLink="/login" [queryParams]="{ origin: environment.configurator_url }" class="link-item">
					<div>
						<div class="header">Configurator</div>
						<div class="description">Create and configure Test Analysis, Test Cases and Test Suites</div>
					</div>
				</a>

				<a routerLink="/login" [queryParams]="{ origin: environment.executor_url }" class="link-item">
					<div>
						<div class="header">Executor</div>
						<div class="description">Execute test suites and create test runs</div>
					</div>
				</a>

				<a routerLink="/login" [queryParams]="{ origin: environment.results_url }" class="link-item">
					<div>
						<div class="header">Results</div>
						<div class="description">View the results</div>
					</div>
				</a>

				@if (isUnderDevelopment$ | async) {
					<div class="link-item" onclick="location.href = 'new_url2.html'">
						<div class="header">SOPS Evaluator</div>
						<div class="description">PreProd "TCR/VCR" functional SOP</div>
					</div>
				}

				<a routerLink="/login" [queryParams]="{ origin: environment.reports_url }" class="link-item">
					<div>
						<div class="header">Reports</div>
						<div class="description">View the results in generated reports</div>
					</div>
				</a>

				@if (isUnderDevelopment$ | async) {
					<div class="link-item" onclick="location.href = 'new_url1.html'">
						<div class="header">Review</div>
						<div class="description">Test Artifacts review</div>
					</div>
				}

				@if (environment.environment !== TargetEnvironment.Hero) {
					<a routerLink="/login" [queryParams]="{ origin: environment.vehicle_bookings_url }" class="link-item">
						<div>
							<div class="header">Vehicle Booking</div>
							<div class="description">Book a date interval for test suite connected to a vehicle rig or event</div>
						</div>
					</a>
				}

				@if (environment.environment !== TargetEnvironment.Hero) {
					<a routerLink="/login" [queryParams]="{ origin: environment.vehicle_follow_up_url }" class="link-item">
						<div>
							<div class="header">Vehicle Follow Up</div>
							<div class="description">Follow up the status of test vehicles and export reports for them</div>
						</div>
					</a>
				}

				@if (isNewDDBAndECUCompare$ | async) {
					@if (environment.environment === TargetEnvironment.Default) {
						<div class="link-item" routerLink="/login" [queryParams]="{ origin: environment.deliveryDatabase_url }">
							<div class="header">Delivery Database (old)</div>
							<div class="description">Not available for new deliveries, use DDB. Can still be used for FPC searcher</div>
						</div>
					}
					<a routerLink="/login" [queryParams]="{ origin: environment.ddb_url }" class="link-item">
						<div>
							<div class="header">DDB</div>
							<div class="description">Manage and track deliveries for software, hardware, boot and calibration files.</div>
						</div>
					</a>
					<div class="link-item" routerLink="/login" [queryParams]="{ origin: environment.ecu_compare_url }">
						<div class="header">ECU Compare</div>
						<div class="description">Evaluate ECU configurations (readout) against xOPS and get recommended deliveries for a given SOP, test period and test level.</div>
					</div>
				} @else {
					@if (environment.environment === TargetEnvironment.Default) {
						<div class="link-item" routerLink="/login" [queryParams]="{ origin: environment.deliveryDatabase_url }">
							<div class="header">Delivery Database</div>
							<div class="description">Deliveries for SESAMM</div>
						</div>
						<a routerLink="/login" [queryParams]="{ origin: environment.ddb_url }" class="link-item">
							<div>
								<div class="header">DDB</div>
								<div class="description">Deliveries for TEESA</div>
							</div>
						</a>
					} @else {
						<a routerLink="/login" [queryParams]="{ origin: environment.ddb_url }" class="link-item">
							<div>
								<div class="header">DDB</div>
								<div class="description">Manage and track deliveries for software, hardware, boot and calibration files.</div>
							</div>
						</a>
						<div class="link-item" routerLink="/login" [queryParams]="{ origin: environment.ecu_compare_url }">
							<div class="header">ECU Compare</div>
							<div class="description">Evaluate ECU configurations (readout) against xOPS and get recommended deliveries for a given SOP, test period and test level.</div>
						</div>
					}
				}

				@if (isDevTools$ | async) {
					<div class="link-item" routerLink="/dev-tools">
						<div class="header">Dev Tools</div>
						<div class="description">Developer tools</div>
					</div>
				}
				@if (isNexus$ | async) {
					<a routerLink="/login" [queryParams]="{ origin: environment.nexus_url }" class="link-item">
						<div>
							<div class="header">Nexus</div>
							<div class="description">To be able to use the Fenix tool chain and DDB, a dedicated user management tool is used.</div>
						</div>
					</a>
				}

				@if (environment.environment !== TargetEnvironment.Hero) {
					<a routerLink="/login" [queryParams]="{ origin: environment.analyzer_url }" class="link-item">
						<div>
							<div class="header">Analyzer</div>
							<div class="description">Correlate test results with logs, environment data and system changes to accelerate root cause analysis and classification</div>
						</div>
					</a>
				}
				@if ((isDevTools$ | async) && environment.environment !== TargetEnvironment.Hero) {
					<a routerLink="/login" [queryParams]="{ origin: environment.webanalytics_url }" class="link-item">
						<div>
							<div class="header">Web Analytics</div>
							<div class="description">Internal web analytics for applications</div>
						</div>
					</a>
				}
			</div>
		}
	</div>
</div>
